import React, { useEffect, useState } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputController from 'components/Form/InputController';
import { FileImageValid, ModalType, ROOT_API } from 'constants/common';
import { toast } from 'components/Toast';

import { ErrorForm } from 'constants/error';
import * as yup from 'yup';
import SelectController from 'components/Form/SelectController';
import { SocialManagerFormValidate } from 'utils/validation';
import { mappingOptionSelect } from 'utils/mapping';
import { useCreateSocialMutation, useUpdateElementSocialMutation } from 'services/social';
import isEmpty from 'lodash/isEmpty';

const CreateSocialModal = ({ isOpen, socialDetail, optionData ,onClose, refetch }) => {
  const cancelRef = React.useRef();
  const createSocialMutation = useCreateSocialMutation();
  const updateSocialMutation = useUpdateElementSocialMutation();
  const [brandingSelect,setBrandingSelect] = useState() 
  const [error, setError] = useState();

  //   const Inputs = {
  //     Name: String,
  //     Id: String,
  //     Secrect: String,
  //     Active: Boolean,
  //   };

  const { control, handleSubmit,reset } = useForm({
    resolver: yupResolver(SocialManagerFormValidate),
    defaultValues: {
      name: "",
      accessToken: "",
      clientId: "",
      clientSecret: "",
      brandingId: undefined,
      postApiUrl:""
    },
  });

  useEffect(() => {
      if (!isEmpty(optionData?.data)) {
        setBrandingSelect(mappingOptionSelect(optionData?.data, "name", "_id"));
      }
    }, []);

    useEffect(() => {
      if (socialDetail) {
        reset({ name: socialDetail.name, 
          accessToken: socialDetail.accessToken,
          clientId: socialDetail.clientId,
          clientSecret: socialDetail.clientSecret,
          brandingId: brandingSelect?.find(item => item?.value === socialDetail?.brandingId?._id),
          postApiUrl: socialDetail.postApiUrl,
         });
      }
    }, [socialDetail,brandingSelect]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${socialDetail ? 'Cập nhật' : 'Tạo'} thông tin thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };

  const handleError = error => {
    toast.showMessageError(
      error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || `${socialDetail ? 'Cập nhật' : 'Tạo'} thông tin thành công`
    );
  };

  const onSubmit = async values=> {
    if (socialDetail) {
      updateSocialMutation.mutate(
        { name:values.name ,accessToken: values.accessToken, clientId: values.clientId,
          clientSecret: values.clientSecret,
          brandingId: values.brandingId.value,
          postApiUrl: values.postApiUrl,
          socialId: socialDetail._id
        },
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    } else {
      createSocialMutation.mutate(
        { name:values.name ,accessToken: values.accessToken, clientId: values.clientId,
          clientSecret: values.clientSecret,
          brandingId: values.brandingId.value,
          postApiUrl: values.postApiUrl},
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    }
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'}>
          <AlertDialogHeader textTransform="uppercase">{socialDetail ? 'Cập nhật' : 'Tạo'} Social</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <form>
              <InputController control={control} name="name" label="Name" styleContainer={{ mt: 3 }} isRequired />
              <InputController control={control} name="accessToken" label="Access Token" styleContainer={{ mt: 3 }} isRequired/>
              <InputController control={control} name="clientId" label="Client Id" styleContainer={{ mt: 3 }} isRequired />
              <InputController control={control} name="clientSecret" label="Client Secret" styleContainer={{ mt: 3 }} isRequired/>
              <SelectController control={control} name="brandingId" label={"Branding"} placeholder="Chọn Branding" options={brandingSelect} styleContainer={{ mt: 3 }} isRequired/>
              <InputController control={control} name="postApiUrl" label="Post Api Url" styleContainer={{ mt: 3 }} isRequired/>
            </form>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createSocialMutation.isPending || updateSocialMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {socialDetail ? 'Cập nhật' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default CreateSocialModal;
